export enum ServiceType {
    php = 'php',
    external = 'external',
}
